import { generateTranslations } from '../i18n/translation';

const namespace = 'practiceactivity/calendarCell.psa';

const translations = generateTranslations(namespace, {
  kanBekreftes: {
    nb: 'Klar til bekreftelse',
    en: 'Ready to be confirmed',
  },
  bekreftetMenManglerKapasitet: {
    nb: 'Bekreftet men mangler kapasitet',
    en: 'Confirmed but missing capacity',
  },
  bekreftetOgHarKapasitet: {
    nb: 'Bekreftet og fylt kapasitet',
    en: 'Confirmed and filled capacity',
  },
  bekreftetMenManglerFordeling: {
    nb: 'Studenter mangler veiledere',
    en: 'Students not assigned to supervisors',
  },
  klarForGjennomfoering: {
    nb: `Klar til gjennomføring`,
    en: `Ready to be started`,
  },
  gjennomfoert: {
    nb: 'Gjennomført',
    en: 'Completed',
  },
  avtalefeil: {
    nb: 'Det finnes bestillinger/besvarelser som faller utenfor en avtale',
    en: 'There are orders/responses that are not connected to an agreement',
  },
});

export default translations;
